import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { toast } from 'react-toastify';

import axios from 'axios';

import { Button, Modal, Textarea, Heading } from '../../shared/ui';
import { useLazyGetConsultationByCodeQuery } from '../../services/users.api';

import AdBanner from '../ad-banner';

import Header from '../header';

import { UnicornReview } from './unicorn-review';

export const ClientEnd = () => {
  const [getConsultations, { data: consultations }] = useLazyGetConsultationByCodeQuery();
  const params = useParams();
  const roomName = params.id;
  const successMess = params.success;
  const [hoverUnicorn, setHoverUnicorn] = useState(0);
  const [activeUnicorn, setActiveUnicorn] = useState(0);
  const [hoverUnicornQuality, setHoverUnicornQuality] = useState(0);
  const [activeUnicornQuality, setActiveUnicornQuality] = useState(0);
  const [note, setNote] = useState('');
  const [isShowModal, setIsShowModal] = useState(false);
  const [isBlocked, setIsBlocked] = useState(false);
  const [isSended, setisSended] = useState(!!successMess);
  const navigate = useNavigate();
  useEffect(() => {
    getConsultations(String(roomName));
  }, []);

  const handleSaveReview = async () => {
    try {
      const data = {
        video_score: activeUnicornQuality,
        consultation_score: activeUnicorn,
        note: note,
        consultation: consultations ? `/api/v1/consultations/${consultations.id}` : '',
        author: null,
        client: consultations ? consultations.client_entity : null,
      };
      const res = await axios.post(`${import.meta.env.VITE_REACT_APP_API_URL}/api/v1/reviews`, data, {});
      if (res.status >= 200 && res.status < 300) {
        setIsShowModal(true);
        setActiveUnicorn(0);
        setActiveUnicornQuality(0);
        setIsBlocked(true);
        setisSended(true);
        setNote('');
        navigate('success');
      }
    } catch (error) {
      toast.error('Произошла ошибка');
      console.log(error);
    }
  };

  return (
    <div className="w-full h-screen flex flex-col md:flex-row">
      <div className="flex flex-col items-center justify-center w-full md:max-w-[350px] h-full order-last md:order-first">
        <div className="w-full flex flex-col items-center gap-2.5 pt-[10px]">
          {/* <p className="text-lg font-bold text-ink-muted">Реклама</p> */}
          <AdBanner />
          {/* <div className="flex w-full max-w-[240px] h-[400px] items-center justify-center bg-surface rounded-card lg:rounded-popup" /> */}
        </div>
      </div>
      <div className="w-full flex flex-col justify-end ">
        {/* <div className="w-full h-headerHeightMobile lg:h-headerHeight bg-white shadow-raised">
          <div className="w-full max-w-[1280px] h-full py-[8px] px-[15px] lg:py-2 mx-auto">
            <div className="h-full flex items-center justify-between">
              <div className="flex flex-col">
                <div className="text-xs md:text-base text-black font-bold leading-3 md:leading-4 mb-[3px] md:mb-[7px]">
                  BETA
                </div>
                <Link to={LANDING}>
                  <LogoIcon className="w-[80px] h-[15px] lg:w-[155px] lg:h-[30px]" />
                </Link>
              </div>
            </div>
          </div>
        </div> */}

        <Header />
        <div className="w-full h-[85%] py-[20px] sm:py-[30px] lg:py-6 flex flex-col justify-center items-center">
          <Heading size="lg" className="text-center mb-2.5">
            {!isSended ? 'Видео-конференция завершилась' : 'Спасибо за отзыв'}
          </Heading>
          <p className="text-ink-muted text-ui lg:text-body-l text-center mb-4 lg:mb-6">
            ZiNGiZi каждый день старается стать лучше для своих пользователей.
          </p>
          {!isSended && (
            <div className="max-w-[420px] mx-auto bg-white rounded-card lg:rounded-popup p-5 shadow-raised sm:mb-8">
              <p className="text-ui-strong lg:text-heading-md text-center text-ink mb-3.5">Оцените работу психолога</p>
              <div className="flex justify-center mb-5 lg:mb-6">
                <UnicornReview
                  hoverUnicorn={hoverUnicorn}
                  unicornActive={activeUnicorn}
                  setHoverUnicorn={setHoverUnicorn}
                  setUnicornActive={setActiveUnicorn}
                />
              </div>
              <p className="text-ui-strong lg:text-heading-md text-center text-ink mb-3.5">
                Оцените качество связи ZiNGiZi
              </p>
              <div className="flex justify-center mb-5 lg:mb-6">
                <UnicornReview
                  hoverUnicorn={hoverUnicornQuality}
                  unicornActive={activeUnicornQuality}
                  setHoverUnicorn={setHoverUnicornQuality}
                  setUnicornActive={setActiveUnicornQuality}
                />
              </div>
              <div className="flex flex-col">
                <Textarea
                  autoGrow
                  className="mb-5 lg:mb-6"
                  value={note}
                  onChange={(event) => setNote(event.target.value)}
                  placeholder="Напишите о качестве работы сервиса и психолога"
                  label="Дополнительный комментарий"
                />
                <Button
                  disabled={(activeUnicorn === 0 && activeUnicornQuality === 0) || isBlocked}
                  size="lg"
                  fullWidth
                  onClick={() => handleSaveReview()}
                >
                  Отправить
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>

      <Modal
        isOpen={isShowModal}
        onClose={() => setIsShowModal(false)}
        size="sm"
        title="Спасибо за отзыв"
        footer={
          <Button size="md" variant="dark" onClick={() => setIsShowModal(false)}>
            Хорошо
          </Button>
        }
      >
        <p className="text-ui text-ink-muted lg:text-body-l">
          Ваш отзыв успешно отправлен. Он поможет улучшить работу сервисов ZiNGiZi.
        </p>
      </Modal>
    </div>
  );
};
